// extracted by mini-css-extract-plugin
export default {"howItWork":"REB1r","title":"YcTrF","stepsList":"hohp3","step":"lhXBt","stepText":"pnFrY","icon":"bTXoi"};